/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md: exports a function, not a component. */
const POSITION =
  'before:absolute before:left-7 before:top-1 before:text-xs before:font-semibold before:leading-5 before:text-foreground';

const MONTH_CONTENT_CLASSES = [
  "before:content-['Jan']",
  "before:content-['Feb']",
  "before:content-['Mar']",
  "before:content-['Apr']",
  "before:content-['May']",
  "before:content-['Jun']",
  "before:content-['Jul']",
  "before:content-['Aug']",
  "before:content-['Sep']",
  "before:content-['Oct']",
  "before:content-['Nov']",
  "before:content-['Dec']",
];

export function schedulerMonthLabelClass(day: Date): string {
  return `${POSITION} ${MONTH_CONTENT_CLASSES[day.getMonth()]}`;
}
